import { render } from "./App.vue?vue&type=template&id=4a58f7c8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4a58f7c8&lang=css"

import exportComponent from "/Users/chlee/my/chekt/chekt-app-videoai/hosting/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__